import React, { useEffect, useState } from 'react';
import { adaptiveService } from './adaptiveService';

export const AdaptiveGovernancePanel: React.FC = () => {
  const [stability, setStability] = useState<any>(null);
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const data = await adaptiveService.getAdaptiveData();
      setStability(data.stability);
      setLogs(data.logs);
    } catch (err) {
      console.error('Failed to fetch adaptive governance data', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRollback = async (logId: string) => {
    if (!window.confirm('Are you sure you want to rollback this adaptive threshold change?')) return;
    try {
      await adaptiveService.rollbackThreshold(logId);
      alert('Rollback successful');
      fetchData();
    } catch (err: any) {
      alert('Rollback failed: ' + (err.message || 'Error'));
    }
  };

  if (loading) return <div>Loading Adaptive Governance Panel...</div>;
  if (!stability) return <div>No stability data</div>;

  return (
    <div className="module-adaptive">
      <h3>Adaptive Governance & Self-Healing</h3>
      
      <div className="stability-header">
        <div className="stability-meter">
          <label>Platform Stability Score</label>
          <div className={`score-circle ${stability.status.toLowerCase()}`}>
            {stability.score}
          </div>
          <span className="status-text">{stability.status}</span>
        </div>
        
        <div className="volatility-metrics">
          <div>Margin Volatility: {stability.metrics.margin_volatility}%</div>
          <div>Churn Accel: {stability.metrics.churn_acceleration}%</div>
          <div>Fraud Volatility: {stability.metrics.fraud_volatility}%</div>
        </div>
      </div>

      <div className="shift-history">
        <h4>Recent Adaptive Threshold Shifts</h4>
        <table>
          <thead>
            <tr>
              <th>Threshold</th>
              <th>Previous</th>
              <th>New</th>
              <th>Reason</th>
              <th>Timestamp</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id}>
                <td>{log.threshold_type}</td>
                <td>{log.previous_value}</td>
                <td>{log.new_value}</td>
                <td>{log.reason}</td>
                <td>{new Date(log.created_at).toLocaleString()}</td>
                <td>
                  <button onClick={() => handleRollback(log.id)} className="btn-rollback">
                    Rollback
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
